var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticStyle:{"text-align":"center"},attrs:{"title":"编辑"},on:{"click":function($event){return _vm.upBox(_vm.value)}}},[_c('i',{staticClass:"el-icon-edit-outline"})])])}
var staticRenderFns = []

export { render, staticRenderFns }